<div class="tw:w-full tw:max-w-7xl tw:mx-auto tw:px-4 tw:pt-24">
  <div class="tw:flex tw:flex-wrap error-page tw:items-center">
    <div class="error-page-content tw:w-full tw:md:w-1/2">
      <h1 i18n>Access denied</h1>
      <p i18n>
        You are trying to view a page you are not allowed to see. If you are not logged in, log in. Otherwise, check
        that your account should be able to view it.
      </p>
      <button class="ga-button ga-button--primary" (click)="backToHome()" i18n> Back to Visma.net Home </button>
    </div>
    <div class="error-page-image tw:w-full tw:md:w-1/2 tw:h-[384px]">
      <div class="tw:w-[384px] tw:h-[384px] unauthorized-image"> </div>
    </div>
  </div>
</div>
